module.exports = fox._r("images/promo/tutorial/04.jpg", __webpack_public_path__ + "_/_/_/common/frame/images/promo/tutorial/04.jpg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/promo/tutorial/04.jpg
// module id = 445
// module chunks = 2